var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 21.6004C17.3023 21.6004 21.6004 17.3023 21.6004 12.0004C21.6004 6.69846 17.3023 2.40039 12.0004 2.40039C6.69846 2.40039 2.40039 6.69846 2.40039 12.0004C2.40039 17.3023 6.69846 21.6004 12.0004 21.6004Z",
    fill: "#0100C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.3691V16.8731",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2807 7.61984C12.2807 7.77448 12.1553 7.89984 12.0007 7.89984C11.8461 7.89984 11.7207 7.77448 11.7207 7.61984C11.7207 7.4652 11.8461 7.33984 12.0007 7.33984C12.1553 7.33984 12.2807 7.4652 12.2807 7.61984Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b099c1a934e130c29547ce66bf9e230f.svg";
export { ForwardRef as ReactComponent };